/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'duplicate': {
    width: 14,
    height: 16,
    viewBox: '0 0 14 16',
    data: '<path pid="0" d="M12.514 14.536V4.357h-8.09v10.18h8.09zm0-11.608c.391 0 .737.142 1.037.425.3.284.449.619.449 1.004v10.18c0 .385-.15.725-.45 1.02-.299.295-.645.443-1.036.443h-8.09c-.391 0-.737-.148-1.036-.443-.3-.295-.45-.635-.45-1.02V4.356c0-.385.15-.72.45-1.004.3-.283.645-.425 1.037-.425h8.089zM10.3 0v1.464h-8.85v10.179H0V1.463C0 1.079.144.739.432.444A1.379 1.379 0 0 1 1.452 0h8.85z" _fill="#9D9D9D" fill-rule="evenodd"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/duplicate.js